import {
  DomDocsUploadPayload,
  GuardianDetailsPayload,
  ICurrencyAccountType,
  MinorDetailsPayload,
  MinorDocsPayload,
  RegularSavingsDetailsPayload,
  RegularSavingsDocsPayload,
  SubmitSwiftDocsPayload,
} from "../models/IEnums.model";
import { Source, SwiftSavingsDetails } from "../types/swiftSavings";
import { FC } from "react";
import WhatsappIcon from "../assets/icons/WhatsappIcon";
import PhoneIcon from "../assets/icons/PhoneIcon";
import PersonalIcon from "../assets/icons/PersonalIcon";
import { returnConfigVariable } from "./helpers";
import YouverifyPassiveLiveness from "youverify-passive-liveness-web";
import YouverifyLiveness from "youverify-liveness-web";
import {
  AcctNoNin,
  CustomerDocData,
  EmploymentDetailsData,
  ProofOfAddressData,
  SelectUpgradeAccountType,
  SelectUpgradeAccountTypeData,
  SummaryDetails,
  UpgradeAccountRequest,
} from "../types/upgradeAccount";

export const YouVerifyModule =
  returnConfigVariable("REACT_APP_YOUVERIFY_MODULE") === "passive"
    ? YouverifyPassiveLiveness
    : YouverifyLiveness;

export const accountTypes = {
  swiftSavings: "swift savings",
  regularSavings: "mudarabah savings",
  jointSavings: "joint savings",
  domiciliarySavings: "domiciliary savings",
  minorSavings: "minor savings",
  current: "current",
  jointCurrent: "joint current",
  domiciliaryCurrent: "domiciliary current",
};

export const accountOpeningSteps = {
  bvnNinValidation: "bvn-validation",
  accountValidation: "account-validation",
  guardianDetails: "guardian-details",
  minorDetails: "minor-details",
  otp: "otp",
  updateDetail: "update-detail",
  documentUpload: "document-upload",
  accountOpeningSuccess: "account-opening-success",
  addReference: "add-reference",
  // addRefAcurrent: "addRefAcurrent",
};
export const accountSteps = {
  minor: [
    "Account Validation",
    "Guardian Details",
    "Minor Details",
    "Document Upload",
  ],
  swift: ["BVN or NIN Validation", "Update Details", "Document Upload"],
  others: ["BVN and NIN Validation", "Update Details", "Document Upload"],
  current: [
    "BVN Validation",
    "Update Details",
    "Add Reference",
    "Document Upload",
  ],
};

export const links = {
  termsAndConditionsPDF: "../assets/pdf/tc.pdf",
};

export const currencyCodes = {
  GBP: "826",
  USD: "840",
  EUR: "978",
  NGN: "566",
};

export const monthNames = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
};

export const daysArr: string[] = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];

export const minorRelationshipStatus: string[] = [
  "Parent",
  "Legal Guardian",
  "Other",
];

export const nextOfKinRelationships = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Son",
  "Daughter",
  "Husband",
  "Wife",
  "Partner",
  "Grandfather",
  "Grandmother",
  "Grandson",
  "Granddaughter",
  "Uncle",
  "Aunt",
  "Nephew",
  "Niece",
  "Cousin",
  "Guardian",
  "Legal Guardian",
  "Stepfather",
  "Stepmother",
  "Stepbrother",
  "Stepsister",
  "Stepson",
  "Stepdaughter",
  "Friend",
  "Colleague",
  "Employer",
  "Employee",
  "Caretaker",
];

export const monthsArr: string[] = Object.keys(monthNames);

export const idCardTypes: string[] = [
  "International passport",
  "National ID card",
  "Permanent Voter's card",
  `Nigerian Driver's licence`,
];
export const statesInNigeria = [
  {
    name: "Abia",
    lgas: [
      "Aba North",
      "Aba South",
      "Arochukwu",
      "Bende",
      "Ikwuano",
      "Isiala Ngwa North",
      "Isiala Ngwa South",
      "Isuikwuato",
      "Obi Ngwa",
      "Ohafia",
      "Osisioma",
      "Ugwunagbo",
      "Ukwa East",
      "Ukwa West",
      "Umuahia North",
      "Umuahia South",
      "Umu Nneochi",
    ],
  },
  {
    name: "Adamawa",
    lgas: [
      "Demsa",
      "Fufore",
      "Ganye",
      "Girei",
      "Gombi",
      "Guyuk",
      "Hong",
      "Jada",
      "Lamurde",
      "Madagali",
      "Maiha",
      "Mayo-Belwa",
      "Michika",
      "Mubi North",
      "Mubi South",
      "Numan",
      "Shelleng",
      "Song",
      "Toungo",
      "Yola North",
      "Yola South",
    ],
  },
  {
    name: "AkwaIbom",
    lgas: [
      "Abak",
      "Eastern Obolo",
      "Eket",
      "Esit-Eket",
      "Essien Udim",
      "Etim-Ekpo",
      "Etinan",
      "Ibeno",
      "Ibesikpo Asutan",
      "Ibiono-Ibom",
      "Ika",
      "Ikono",
      "Ikot Abasi",
      "Ikot Ekpene",
      "Ini",
      "Itu",
      "Mbo",
      "Mkpat-Enin",
      "Nsit-Atai",
      "Nsit-Ibom",
      "Nsit-Ubium",
      "Obot Akara",
      "Okobo",
      "Onna",
      "Oron",
      "Oruk Anam",
      "Udung-Uko",
      "Ukanafun",
      "Uruan",
      "Urue-Offong/Oruko",
      "Uyo",
    ],
  },
  {
    name: "Anambra",
    lgas: [
      "Aguata",
      "Anambra East",
      "Anambra West",
      "Anaocha",
      "Awka North",
      "Awka South",
      "Ayamelum",
      "Dunukofia",
      "Ekwusigo",
      "Idemili North",
      "Idemili South",
      "Ihiala",
      "Njikoka",
      "Nnewi North",
      "Nnewi South",
      "Ogbaru",
      "Onitsha North",
      "Onitsha South",
      "Orumba North",
      "Orumba South",
      "Oyi",
    ],
  },
  {
    name: "Bauchi",
    lgas: [
      "Alkaleri",
      "Bauchi",
      "Bogoro",
      "Damban",
      "Darazo",
      "Dass",
      "Gamawa",
      "Ganjuwa",
      "Giade",
      "Itas/Gadau",
      "Jama'are",
      "Katagum",
      "Kirfi",
      "Misau",
      "Ningi",
      "Shira",
      "Tafawa Balewa",
      "Toro",
      "Warji",
      "Zaki",
    ],
  },
  {
    name: "Bayelsa",
    lgas: [
      "Brass",
      "Ekeremor",
      "Kolokuma/Opokuma",
      "Nembe",
      "Ogbia",
      "Sagbama",
      "Southern Ijaw",
      "Yenagoa",
    ],
  },
  {
    name: "Benue",
    lgas: [
      "Ado",
      "Agatu",
      "Apa",
      "Buruku",
      "Gboko",
      "Guma",
      "Gwer East",
      "Gwer West",
      "Katsina-Ala",
      "Konshisha",
      "Kwande",
      "Logo",
      "Makurdi",
      "Obi",
      "Ogbadibo",
      "Ohimini",
      "Oju",
      "Okpokwu",
      "Oturkpo",
      "Tarka",
      "Ukum",
      "Ushongo",
      "Vandeikya",
    ],
  },
  {
    name: "Borno",
    lgas: [
      "Abadam",
      "Askira/Uba",
      "Bama",
      "Bayo",
      "Biu",
      "Chibok",
      "Damboa",
      "Dikwa",
      "Gubio",
      "Guzamala",
      "Gwoza",
      "Hawul",
      "Jere",
      "Kaga",
      "Kala/Balge",
      "Konduga",
      "Kukawa",
      "Kwaya Kusar",
      "Mafa",
      "Magumeri",
      "Maiduguri",
      "Marte",
      "Mobbar",
      "Monguno",
      "Ngala",
      "Nganzai",
      "Shani",
    ],
  },
  {
    name: "CrossRiver",
    lgas: [
      "Abi",
      "Akamkpa",
      "Akpabuyo",
      "Bakassi",
      "Bekwarra",
      "Biase",
      "Boki",
      "Calabar Municipal",
      "Calabar South",
      "Etung",
      "Ikom",
      "Obanliku",
      "Obubra",
      "Obudu",
      "Odukpani",
      "Ogoja",
      "Yakurr",
      "Yala",
    ],
  },
  {
    name: "Delta",
    lgas: [
      "Aniocha North",
      "Aniocha South",
      "Bomadi",
      "Burutu",
      "Ethiope East",
      "Ethiope West",
      "Ika North East",
      "Ika South",
      "Isoko North",
      "Isoko South",
      "Ndokwa East",
      "Ndokwa West",
      "Okpe",
      "Oshimili North",
      "Oshimili South",
      "Patani",
      "Sapele",
      "Udu",
      "Ughelli North",
      "Ughelli South",
      "Ukwuani",
      "Uvwie",
      "Warri North",
      "Warri South",
      "Warri South West",
    ],
  },
  {
    name: "Ebonyi",
    lgas: [
      "Abakaliki",
      "Afikpo North",
      "Afikpo South",
      "Ebonyi",
      "Ezza North",
      "Ezza South",
      "Ikwo",
      "Ishielu",
      "Ivo",
      "Izzi",
      "Ohaozara",
      "Ohaukwu",
      "Onicha",
    ],
  },
  {
    name: "Edo",
    lgas: [
      "Akoko-Edo",
      "Egor",
      "Esan Central",
      "Esan North-East",
      "Esan South-East",
      "Esan West",
      "Etsako Central",
      "Etsako East",
      "Etsako West",
      "Igueben",
      "Ikpoba Okha",
      "Orhionmwon",
      "Oredo",
      "Ovia North-East",
      "Ovia South-West",
      "Owan East",
      "Owan West",
      "Uhunmwonde",
    ],
  },
  {
    name: "Ekiti",
    lgas: [
      "Ado-Ekiti",
      "Efon",
      "Ekiti East",
      "Ekiti South-West",
      "Ekiti West",
      "Emure",
      "Gbonyin",
      "Ido-Osi",
      "Ijero",
      "Ikere",
      "Ikole",
      "Ilejemeje",
      "Irepodun/Ifelodun",
      "Ise/Orun",
      "Moba",
      "Oye",
    ],
  },
  {
    name: "Enugu",
    lgas: [
      "Aninri",
      "Awgu",
      "Enugu East",
      "Enugu North",
      "Enugu South",
      "Ezeagu",
      "Igbo Etiti",
      "Igbo Eze North",
      "Igbo Eze South",
      "Isi Uzo",
      "Nkanu East",
      "Nkanu West",
      "Nsukka",
      "Oji River",
      "Udenu",
      "Udi",
      "Uzo-Uwani",
    ],
  },
  {
    name: "Gombe",
    lgas: [
      "Akko",
      "Balanga",
      "Billiri",
      "Dukku",
      "Funakaye",
      "Gombe",
      "Kaltungo",
      "Kwami",
      "Nafada",
      "Shongom",
      "Yamaltu/Deba",
    ],
  },
  {
    name: "Imo",
    lgas: [
      "Aboh Mbaise",
      "Ahiazu Mbaise",
      "Ehime Mbano",
      "Ezinihitte",
      "Ideato North",
      "Ideato South",
      "Ihitte/Uboma",
      "Ikeduru",
      "Isiala Mbano",
      "Isu",
      "Mbaitoli",
      "Ngor Okpala",
      "Njaba",
      "Nkwerre",
      "Nwangele",
      "Obowo",
      "Oguta",
      "Ohaji/Egbema",
      "Okigwe",
      "Onuimo",
      "Orlu",
      "Orsu",
      "Oru East",
      "Oru West",
      "Owerri Municipal",
      "Owerri North",
      "Owerri West",
    ],
  },
  {
    name: "Jigawa",
    lgas: [
      "Auyo",
      "Babura",
      "Biriniwa",
      "Birnin Kudu",
      "Buji",
      "Dutse",
      "Gagarawa",
      "Garki",
      "Gumel",
      "Guri",
      "Gwaram",
      "Gwiwa",
      "Hadejia",
      "Jahun",
      "Kafin Hausa",
      "Kaugama",
      "Kazaure",
      "Kiri Kasama",
      "Kiyawa",
      "Maigatari",
      "Malam Madori",
      "Miga",
      "Ringim",
      "Roni",
      "Sule Tankarkar",
      "Taura",
      "Yankwashi",
    ],
  },
  {
    name: "Kaduna",
    lgas: [
      "Birnin Gwari",
      "Chikun",
      "Giwa",
      "Igabi",
      "Ikara",
      "Jaba",
      "Jema'a",
      "Kachia",
      "Kaduna North",
      "Kaduna South",
      "Kagarko",
      "Kajuru",
      "Kaura",
      "Kauru",
      "Kubau",
      "Kudan",
      "Lere",
      "Makarfi",
      "Sabon Gari",
      "Sanga",
      "Soba",
      "Zangon Kataf",
      "Zaria",
    ],
  },
  {
    name: "Kano",
    lgas: [
      "Ajingi",
      "Albasu",
      "Bagwai",
      "Bebeji",
      "Bichi",
      "Bunkure",
      "Dala",
      "Dambatta",
      "Dawakin Kudu",
      "Dawakin Tofa",
      "Doguwa",
      "Fagge",
      "Gabasawa",
      "Garko",
      "Garun Mallam",
      "Gaya",
      "Gezawa",
      "Gwale",
      "Gwarzo",
      "Kabo",
      "Kano Municipal",
      "Karaye",
      "Kibiya",
      "Kiru",
      "Kumbotso",
      "Kunchi",
      "Kura",
      "Madobi",
      "Makoda",
      "Minjibir",
      "Nasarawa",
      "Rano",
      "Rimin Gado",
      "Rogo",
      "Shanono",
      "Sumaila",
      "Takai",
      "Tarauni",
      "Tofa",
      "Tsanyawa",
      "Tudun Wada",
      "Ungogo",
      "Warawa",
      "Wudil",
    ],
  },
  {
    name: "Katsina",
    lgas: [
      "Bakori",
      "Batagarawa",
      "Batsari",
      "Baure",
      "Bindawa",
      "Charanchi",
      "Dan Musa",
      "Dandume",
      "Danja",
      "Daura",
      "Dutsi",
      "Dutsin Ma",
      "Faskari",
      "Funtua",
      "Ingawa",
      "Jibia",
      "Kafur",
      "Kaita",
      "Kankara",
      "Kankia",
      "Katsina",
      "Kurfi",
      "Kusada",
      "Mai'Adua",
      "Malumfashi",
      "Mani",
      "Mashi",
      "Matazu",
      "Musawa",
      "Rimi",
      "Sabuwa",
      "Safana",
      "Sandamu",
      "Zango",
    ],
  },
  {
    name: "Kebbi",
    lgas: [
      "Aleiro",
      "Arewa Dandi",
      "Argungu",
      "Augie",
      "Bagudo",
      "Birnin Kebbi",
      "Bunza",
      "Dandi",
      "Fakai",
      "Gwandu",
      "Jega",
      "Kalgo",
      "Koko/Besse",
      "Maiyama",
      "Ngaski",
      "Sakaba",
      "Shanga",
      "Suru",
      "Wasagu/Danko",
      "Yauri",
      "Zuru",
    ],
  },
  {
    name: "Kogi",
    lgas: [
      "Adavi",
      "Ajaokuta",
      "Ankpa",
      "Bassa",
      "Dekina",
      "Ibaji",
      "Idah",
      "Igalamela-Odolu",
      "Ijumu",
      "Kabba/Bunu",
      "Kogi",
      "Lokoja",
      "Mopa-Muro",
      "Ofu",
      "Ogori/Mangongo",
      "Okehi",
      "Okene",
      "Olamaboro",
      "Omala",
      "Yagba East",
      "Yagba West",
    ],
  },
  {
    name: "Kwara",
    lgas: [
      "Asa",
      "Baruten",
      "Edu",
      "Ekiti",
      "Ifelodun",
      "Ilorin East",
      "Ilorin South",
      "Ilorin West",
      "Irepodun",
      "Isin",
      "Kaiama",
      "Moro",
      "Offa",
      "Oke Ero",
      "Oyun",
      "Pategi",
    ],
  },
  {
    name: "Lagos",
    lgas: [
      "Agege",
      "Ajeromi-Ifelodun",
      "Alimosho",
      "Amuwo-Odofin",
      "Apapa",
      "Badagry",
      "Epe",
      "Eti-Osa",
      "Ibeju-Lekki",
      "Ifako-Ijaiye",
      "Ikeja",
      "Ikorodu",
      "Kosofe",
      "Lagos Island",
      "Lagos Mainland",
      "Mushin",
      "Ojo",
      "Oshodi-Isolo",
      "Shomolu",
      "Surulere",
    ],
  },
  {
    name: "Nasarawa",
    lgas: [
      "Akwanga",
      "Awe",
      "Doma",
      "Karu",
      "Keana",
      "Keffi",
      "Kokona",
      "Lafia",
      "Nasarawa",
      "Nasarawa Egon",
      "Obi",
      "Toto",
      "Wamba",
    ],
  },
  {
    name: "Niger",
    lgas: [
      "Agaie",
      "Agwara",
      "Bida",
      "Borgu",
      "Bosso",
      "Chanchaga",
      "Edati",
      "Gbako",
      "Gurara",
      "Katcha",
      "Kontagora",
      "Lapai",
      "Lavun",
      "Magama",
      "Mariga",
      "Mashegu",
      "Mokwa",
      "Muya",
      "Paikoro",
      "Rafi",
      "Rijau",
      "Shiroro",
      "Suleja",
      "Tafa",
      "Wushishi",
    ],
  },
  {
    name: "Ogun",
    lgas: [
      "Abeokuta North",
      "Abeokuta South",
      "Ado-Odo/Ota",
      "Ewekoro",
      "Ifo",
      "Ijebu East",
      "Ijebu North",
      "Ijebu North East",
      "Ijebu Ode",
      "Ikenne",
      "Imeko Afon",
      "Ipokia",
      "Obafemi Owode",
      "Odeda",
      "Odogbolu",
      "Ogun Waterside",
      "Remo North",
      "Shagamu",
      "Yewa North",
      "Yewa South",
    ],
  },
  {
    name: "Ondo",
    lgas: [
      "Akoko North-East",
      "Akoko North-West",
      "Akoko South-East",
      "Akoko South-West",
      "Akure North",
      "Akure South",
      "Ese Odo",
      "Idanre",
      "Ifedore",
      "Ilaje",
      "Ile Oluji/Okeigbo",
      "Irele",
      "Odigbo",
      "Okitipupa",
      "Ondo East",
      "Ondo West",
      "Ose",
      "Owo",
    ],
  },
  {
    name: "Osun",
    lgas: [
      "Atakumosa East",
      "Atakumosa West",
      "Aiyedaade",
      "Aiyedire",
      "Boluwaduro",
      "Boripe",
      "Ede North",
      "Ede South",
      "Egbedore",
      "Ejigbo",
      "Ife Central",
      "Ife East",
      "Ife North",
      "Ife South",
      "Ifedayo",
      "Ifelodun",
      "Ila",
      "Ilesa East",
      "Ilesa West",
      "Irepodun",
      "Irewole",
      "Isokan",
      "Iwo",
      "Obokun",
      "Odo Otin",
      "Ola Oluwa",
      "Olorunda",
      "Oriade",
      "Orolu",
      "Osogbo",
    ],
  },
  {
    name: "Oyo",
    lgas: [
      "Afijio",
      "Akinyele",
      "Atiba",
      "Atisbo",
      "Egbeda",
      "Ibadan North",
      "Ibadan North-East",
      "Ibadan North-West",
      "Ibadan South-East",
      "Ibadan South-West",
      "Ibarapa Central",
      "Ibarapa East",
      "Ibarapa North",
      "Ido",
      "Irepo",
      "Iseyin",
      "Itesiwaju",
      "Iwajowa",
      "Kajola",
      "Lagelu",
      "Ogbomosho North",
      "Ogbomosho South",
      "Ogo Oluwa",
      "Olorunsogo",
      "Oluyole",
      "Ona Ara",
      "Orelope",
      "Ori Ire",
      "Oyo East",
      "Oyo West",
      "Saki East",
      "Saki West",
      "Surulere",
    ],
  },
  {
    name: "Plateau",
    lgas: [
      "Barkin Ladi",
      "Bassa",
      "Bokkos",
      "Jos East",
      "Jos North",
      "Jos South",
      "Kanam",
      "Kanke",
      "Langtang North",
      "Langtang South",
      "Mangu",
      "Mikang",
      "Pankshin",
      "Qua'an Pan",
      "Riyom",
      "Shendam",
      "Wase",
    ],
  },
  {
    name: "Rivers",
    lgas: [
      "Abua/Odual",
      "Ahoada East",
      "Ahoada West",
      "Akuku-Toru",
      "Andoni",
      "Asari-Toru",
      "Bonny",
      "Degema",
      "Eleme",
      "Emohua",
      "Etche",
      "Gokana",
      "Ikwerre",
      "Khana",
      "Obio/Akpor",
      "Ogba/Egbema/Ndoni",
      "Ogu/Bolo",
      "Okrika",
      "Omuma",
      "Opobo/Nkoro",
      "Oyigbo",
      "Port Harcourt",
      "Tai",
    ],
  },
  {
    name: "Sokoto",
    lgas: [
      "Binji",
      "Bodinga",
      "Dange Shuni",
      "Gada",
      "Goronyo",
      "Gudu",
      "Gwadabawa",
      "Illela",
      "Isa",
      "Kebbe",
      "Kware",
      "Rabah",
      "Sabon Birni",
      "Shagari",
      "Silame",
      "Sokoto North",
      "Sokoto South",
      "Tambuwal",
      "Tangaza",
      "Tureta",
      "Wamako",
      "Wurno",
      "Yabo",
    ],
  },
  {
    name: "Taraba",
    lgas: [
      "Ardo Kola",
      "Bali",
      "Donga",
      "Gashaka",
      "Gassol",
      "Ibi",
      "Jalingo",
      "Karim Lamido",
      "Kurmi",
      "Lau",
      "Sardauna",
      "Takum",
      "Ussa",
      "Wukari",
      "Yorro",
      "Zing",
    ],
  },
  {
    name: "Yobe",
    lgas: [
      "Bade",
      "Bursari",
      "Damaturu",
      "Fika",
      "Fune",
      "Geidam",
      "Gujba",
      "Gulani",
      "Jakusko",
      "Karasuwa",
      "Machina",
      "Nangere",
      "Nguru",
      "Potiskum",
      "Tarmuwa",
      "Yunusari",
      "Yusufari",
    ],
  },
  {
    name: "Zamfara",
    lgas: [
      "Anka",
      "Bakura",
      "Birnin Magaji/Kiyaw",
      "Bukkuyum",
      "Bungudu",
      "Gummi",
      "Gusau",
      "Kaura Namoda",
      "Maradun",
      "Maru",
      "Shinkafi",
      "Talata Mafara",
      "Zurmi",
    ],
  },
  {
    name: "FCT",
    lgas: [
      "Abaji",
      "Bwari",
      "Gwagwalada",
      "Kuje",
      "Kwali",
      "Municipal Area Council",
    ],
  },
];

export const idValidation = [
  {
    id: 1,
    name: "pvc",
    length: 11,
  },
  {
    id: 2,
    name: "international_Passport",
    length: 11,
  },
  {
    id: 3,
    name: "nin",
    length: 11,
  },
  {
    id: 4,
    name: "drivers_license",
    length: 11,
  },
];

export const glCodes = {
  SWIFT_SAVINGS: "210805",
  REGULAR_SAVINGS: "210802",
  MINOR_SAVINGS: "210806",
  DOMICILIARY_SAVINGS: "210802",
  CURRENT: "210155",
  DOMICILIARY_CURRENT: "210155",
};

export const MAX_FILE_UPLOAD_SIZE_FIGURE = 2000;

export const MAX_FILE_UPLOAD_SIZE_TEXT = "2mb";

export const encryptionKeys = {
  PassPhrase: returnConfigVariable("REACT_APP_PASS_PHRASE"),
  SaltValue: returnConfigVariable("REACT_APP_SALT_VALUE"),
  InitialVector: returnConfigVariable("REACT_APP_INITIAL_VECTOR"),
  PasswordIterations: returnConfigVariable("REACT_APP_PASSWORD_ITERATIONS"),
  BlockSize: returnConfigVariable("REACT_APP_BLOCK_SIZE"),
  localStorage: returnConfigVariable("REACT_APP_LOCALSTORAGE_KEY"),
};

export const returnBvnValidationErrorMessages = (type?: Source) => {
  const typeStr = type || "";
  return {
    dateofbirth: {
      title: "Date of Birth information does not match.",
      message: `Date of Birth on ${typeStr} does not match, please visit any branch of the ${
        type === "BVN"
          ? "BVN enrolment bank care"
          : type === "NIN"
            ? "NIMC office"
            : "BVN enrolment bank care or visit the NIMC office"
      } to rectify ${typeStr} Details.`,
    },
    existing: {
      title: `Account Linked to ${typeStr}`,
      message: `There’s already an existing The Alternative Bank account linked to this ${typeStr}. Please click 'Proceed' to continue setting up your account as an existing user.`,
    },
    firstname: {
      title: "First Name does not match",
      message:
        "First Name on BVN and NIN does not match, please visit any branch of the BVN enrolment bank care or visit the NIMC office to rectify NIN Details.",
    },
    gender: {
      title: "Gender information does not match.",
      message:
        "Gender on BVN and NIN does not match, please visit any branch of the BVN enrolment bank care or visit the NIMC office to rectify NIN Details.",
    },
    lastname: {
      title: "Last Name does not match",
      message:
        "Last Name on BVN and NIN does not match, please visit any branch of the BVN enrolment bank care or visit the NIMC office to rectify NIN Details.",
    },
    middlename: {
      title: "Middle Name does not match",
      message:
        "Middle Name on BVN and NIN does not match, please visit any branch of the BVN enrolment bank care or visit the NIMC office to rectify NIN Details.",
    },
    "": {
      title: "",
      message: "",
    },
  };
};

export const flaggedBvnErrorMessage: string =
  "We cannot complete this process as your BVN has been flagged. Please contact your bank or email CBN helpline for more information.";

export const initialSwiftDetails: SwiftSavingsDetails = {
  firstName: "",
  middleName: "",
  lastName: "",
  phoneNumber: "",
  dob: "",
  gender: "",
  houseNumber: "",
  streetName: "",
  areaState: "",
  nearestBustopLandmark: "",
  address: "",
  religion: "",
  occupation: "",
  bvn: "",
  nin: "",
  town: "",
  localGovernment: "",
  nextOfKin: "",
  relationshipOfNextOfKin: "",
  employmentInformation: "",
  branchOfDomiciliation: "",
  termsCondition: false,
};

export const initialSwiftDocs: SubmitSwiftDocsPayload = {
  id: 0,
  accountTypecode: "",
  accountTypeName: "",
  signatureUrl: "",
  imageUrl: "",
  debitCardValueAddedService: true,
};

export const initialRegularDocs: RegularSavingsDocsPayload = {
  id: 0,
  signatureUrl: "",
  frontPageIdUrl: "",
  debitCardValueAddedService: true,
  accountTypecode: "",
  accountTypeName: "",
  utilityBill: "",
  identityCardType: 5,
  idCardNumber: "",
  issueDate: "",
  expiryDate: "",
  imageUrl: "",
};

export const initialDomDocs: DomDocsUploadPayload = {
  ...initialRegularDocs,
  currencyOfAccountUSD: "",
  currencyOfAccountGBP: "",
  currencyOfAccountEURO: "",
};

export const minorInitialDetails: MinorDetailsPayload = {
  minorFirstName: "",
  minorMiddleName: "",
  minorLastName: "",
  minorDob: "",
  minorFullName: "",
  minorEmail: "",
  minorNIN: "",
  minorPhoneNumber: "",
  minorReligion: 0,
  minorHouseNumber: "",
  minorStreetName: "",
  minorNearestBusStop: "",
  minorLGA: "",
  minorState: "",
  minorAddress: "",
  minorBirthCertificate: "",
  minorPassport: "",
};

export const guardianInitialDetails: GuardianDetailsPayload = {
  gender: "",
  firstName: "",
  middleName: "",
  lastName: "",
  phoneNumber: "",
  emailAddress: "",
  dob: "",
  houseNumber: "",
  streetName: "",
  areaState: "",
  nearestBustopLandmark: "",
  address: "",
  referralCode: "",
  bvn: "",
  socialMediaId: 0,
  socialMediaHandle: "",
  town: "",
  localGovernment: "",
  termsCondition: false,
  relationship: "",
  title: "",
  religion: 0,
  country: 0,
  maidenName: "",
  branchOfDomiciliation: 0,
};

export const minorDocsInitialState: MinorDocsPayload = {
  id: 0,
  signatureUrl: "",
  minorIdentityUrl: "",
  accountTypecode: "",
  accountTypeName: "",
  utilityBill: "",
  handoverAccount: false,
  imageUrl: "",
};

export const initialRegularDetails: RegularSavingsDetailsPayload = {
  firstName: "",
  middleName: "",
  lastName: "",
  phoneNumber: "",
  emailAddress: "",
  dob: "",
  gender: "",
  houseNumber: "",
  streetName: "",
  areaState: "",
  nearestBustopLandmark: "",
  address: "",
  religion: 0,
  selfEmployementInformation: 0,
  occupation: 0,
  nameOfNextOfKin: "",
  referralCode: "",
  bvn: "",
  socialMediaId: 0,
  socialMediaHandle: "",
  town: "",
  localGovernment: "",
  branchOfDomiciliation: 0,
  termsCondition: false,
  relationshipOfNextOfKin: "",
};

export const MAX_OTP_REQUESTS = 3;

export const tandCServices: string[] = [
  "View all your AltBank accounts and related services in a single log in (including but not limited to your current account, savings account, investments accounts).",
  "Check the available balances on your accounts and view or download recent transactions",
  "Make bill payments, buy airtime",
  "Transfers funds from your AltBank account to designated receiving accounts.Withdraw cash at the ATM using the cardless option",
  "Request for debit card and activate the card on the Platform",
  "Create virtual cards for online shopping",
  "Give us payment and other instructions on your bank account, including setting controls on your payment cards",
  "Open additional accounts",
  "Deposit cheques",
  "Set your transaction limits",
  "Hide Balance",
  "Additional services may be introduced periodically and same shall be accessible on the Platform to Users.",
];

export const idCardRegexMap: Record<number, RegExp> = {
  3: /^[A-Za-z]?\d{0,8}$/, // First character (optional letter), followed by up to 8 digits
  5: /^\d{0,11}$/, // Up to 11 digits
  8: /^[A-Za-z0-9]{0,19}$/, // VIN
  2: /^[A-Z]{0,3}(\d{0,5})?([A-Z]{0,2})?(\d{0,2})?$/, // Drivers License
};

export const idCardValidationRegex: Record<number, RegExp> = {
  3: /^[A-Za-z]{1}\d{8}$/, // 1 letter followed by exactly 8 digits
  5: /^\d{11}$/, // Exactly 11 digits
  8: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{19}$/, // VIN
  2: /^[A-Z]{3}\d{5}[A-Z]{2}\d{1,2}$/, // Nigerian Driver's License: ABC12345DE67
};

export const idCardErrorMsg: Record<number, string> = {
  3: "Passport number must be 9 characters (1 letter + 8 digits)", // First character (optional letter), followed by up to 8 digits
  5: "NIN must be exactly 11 digits", // Up to 11 digits
  8: "PVC number must be 19 characters long and include both letters and numbers.", // Up to 19 digits
  2: "Driver's licence must be in the format ABC12345DE67", // Drivers License
};

export const titles = [
  "Mr.",
  "Mrs.",
  "Miss",
  "Ms.",
  "Mx.",
  "Dr.",
  "Prof.",
  "Engr.",
  "Arch.",
  "Capt.",
  "Lt.",
  "Sir",
  "Dame",
  "Lord",
  "Lady",
  "Hon.",
  "Rev.",
  "Fr.",
  "Sr.",
  "Br.",
  "Imam",
  "Rabbi",
  "Gen.",
  "Col.",
  "Maj.",
  "Amb.",
  "Sen.",
  "Others",
];

export const allCountriesUrl: string =
  "https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/refs/heads/master/json/countries%2Bstates%2Bcities.json";

export const otherOtpOptions: { icon: FC | string; label: string }[] = [
  {
    icon: WhatsappIcon,
    label: "WhatsApp",
  },
  {
    icon: PhoneIcon,
    label: "voice call",
  },
  {
    icon: "#",
    label: "USSD",
  },
  {
    icon: PersonalIcon,
    label: "BVN Face-match",
  },
];
export const channelMap = {
  whatsapp: "WhatsappOtp",
  voice: "VoiceOtp",
  ussd: "USSD",
  bvn: "BvnFaceMatch",
};

export const OTP_MAX_DURATION = 300;

export const activeTasks = [
  {
    id: "yes-or-no",
    questions: [
      {
        question: "Are you ready",
        answer: true,
        errorMessage: "You got it wrong!",
      },
    ],
    timeout: 10000,
  },
  // { id: "complete-the-circle" },
  // { id: "blink", maxBlinks: 2 },
] as any;

export const passiveTasks = [{ id: "passive" }];

export const youVerifyTasks =
  returnConfigVariable("REACT_APP_YOUVERIFY_MODULE") === "passive"
    ? passiveTasks
    : activeTasks;

export const inputInfos: {
  nin: Array<string>;
  bvn: Array<string>;
  [key: string]: any;
} = {
  nin: [
    "The National Identification Number (NIN) is an 11-digit number",
    "Dial *346# to check your NIN",
  ],
  bvn: [
    "The Bank Verification Number (BVN) is an 11-digit number",
    "Dial *565*0# to check your BVN",
  ],
};

export const LS = {
  ATTR_ID: "acquisition_attrib_id", // stable attrib id (ao_...)
  FIRST_TOUCH_TS: "acq_first_touch_ts",
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_TERM: "utm_term",
  GCLID: "gclid",
  FBC: "fbclid",
  TTCLID: "ttclid",
  TWCLID: "twclid",
  SNAPCLID: "snapclid",
  CLICK_ID: "click_id",
  GA_CLIENT_ID: "ga_client_id",
  MS_CLK_ID: "msclkid",
};

export const utmKeys: string[] = [
  LS.UTM_SOURCE,
  LS.UTM_MEDIUM,
  LS.UTM_CAMPAIGN,
  LS.UTM_TERM,
  LS.GCLID,
  LS.FBC,
  LS.TTCLID,
  LS.SNAPCLID,
  LS.CLICK_ID,
  LS.MS_CLK_ID,
  LS.TWCLID,
];

export const accountTypeMap: Record<string, ICurrencyAccountType> = {
  Corporate: ICurrencyAccountType.CORPORATE,
  "Domiciliary Current": ICurrencyAccountType.DOM_CURRENT,
  "Domiciliary Savings": ICurrencyAccountType.DOM_SAVINGS,
};

export const selectUpgradeAcctType: Array<SelectUpgradeAccountType> = [
  {
    name: "Tier 2 Account",
    description: "Enjoy account benefits compared to Tier 1 Accounts",
    type: "tier2",
  },
  {
    name: "Classic Savings Account",
    description: "Enjoy the classic benefits of Tier 3 Accounts",
    type: "tier3",
  },
];

export const initialAcctNoNinData: AcctNoNin = {
  accountNumber: "",
  nin: "",
};

export const initialEmploymentData: EmploymentDetailsData = {
  selectEmploymentStatus: "",
  employerName: "",
  salaryInfo: "",
  employerAddress: "",
  positionHeld: "",
  natureofBusiness: "",
  businessAddress: "",
};

export const initialCustomerAddressData: ProofOfAddressData = {
  houseNumber: "",
  streetName: "",
  nearestLandMark: "",
  lga: "",
  state: "",
  town: "",
};

export const salaryOptions: Array<string> = [
  "Below 100,000",
  "100,000 - 300,000",
  "350,000 - 500,000",
  "500,000 and Above",
];

export const summaryDetails: SummaryDetails = {
  accountName: "Chukwuebuka Anunihu",
  ninUrl: "https://dummyimage.com/600x400/cccccc/000000&text=ID+Image",
  selectEmploymentStatus: "",
  employerName: "TechNova Solutions Ltd",
  salaryInfo: "₦250,000 - ₦400,000",
  employerAddress: "12 Admiralty Way, Lekki Phase 1, Lagos",
  positionHeld: "Frontend Engineer",
  natureofBusiness: "Software Development",
  businessAddress: "Same as employer address",
  accountNumber: "0123456789",
  nin: "12345678901",
  branchName: "Victoria Island Branch",
};

export const selectUpgradeAccountTypeData: SelectUpgradeAccountTypeData = {
  tierType: 0 as 2,
  termsAndConditions: false,
};

export const featuresAndReqs = {
  tier2: {
    features: [
      "Maximum single deposit and cumulative balance/threshold is unlimited.",
      "Daily minimum balance of N1,000.",
      "Attractive interest rate i.e., 1.15% p.a. (30% of MPR)",
      "Issuance of Verve Card and Mastercard.",
      "Online statement.",
      "SMS alert/Email.",
      "Internet & Mobile banking facility.",
      "International funds transfer allowed.",
    ],
    requirements: [
      "Employment information. (i.e., Employer name, Address, Position Held) **would be verified.",
      "NIN Slip",
    ],
  },
  tier3: {
    features: [
      "Maximum single deposit and cumulative balance/threshold is unlimited.",
      "Daily minimum balance of N1,000.",
      "Attractive interest rate i.e., 1.15% p.a. (30% of MPR)",
      "Issuance of Verve Card and Mastercard.",
      "Online statement.",
      "SMS alert/Email.",
      "Internet & Mobile banking facility.",
      "International funds transfer allowed.",
    ],
    requirements: [
      "Address information, Employment information. (i.e., Employer name, Address, Position Held) **would be verified.",
      "NIN Slip",
      "Utility Bill",
      "Liveliness Check",
    ],
  },
};

export const initialMeansOfIdData: CustomerDocData = {
  utilityBill: "",
  ninUrl: "",
};

export const upgradeAcctReqData: UpgradeAccountRequest = {
  accountNumber: "",
  selectEmploymentStatus: "",
  positionHeld: "",
  employerName: "",
  salaryInfo: "",
  employerAddress: "",
  nin: "",
  natureofBusiness: "",
  businessAddress: "",
  houseNumber: "",
  streetName: "",
  nearestLandMark: "",
  lga: "",
  state: "",
  town: "",
  ninUrl: "",
  utilityBill: "",
  tierType: 0 as 2,
  termsAndConditions: false,
};
